module.exports = __webpack_public_path__ + "img/item-5.8f1f6291.png";